<template>
  <div>
    <v-data-table :headers="headers" :items="awarded">
      <template slot="items" slot-scope="props">
        <tr style="text-align: left">
          <td>
            <v-btn icon color="primary" @click="openPOP(props.item)"
              ><v-icon>visibility</v-icon></v-btn
            >
          </td>
          <td>{{ props.item.Id }}</td>
          <td
            >{{ props.item.User.FirstName }} {{ props.item.User.LastName }}</td
          >
          <td>{{ primarySite(props.item.PracticeSiteInformation) }}</td>
          <td>{{ currentStatus(props.item) }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="1050px" v-if="dialog">
      <pop-dialog
        :pop="item"
        v-on:closePop="dialog = false"
        v-on:documentAdded="documentAdded"
        v-on:changedPOP="refreshPOP"
      ></pop-dialog>
    </v-dialog>
  </div>
</template>
<script>
const moduleNameSpace = 'applications'
import { mapGetters, mapActions } from 'vuex'
import ProofOfPaymentVue from './ProofOfPayment.vue'
export default {
  data() {
    return {
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'Application', value: 'ApplicationID' },
        { text: 'Healthcare Provider', value: 'FirstName' },
        { text: 'Practice Site', value: 'SiteInsitutionName' },
        { text: 'Status', value: 'Description' },
      ],
      dialog: false,
      item: {},
    }
  },
  created() {
    this.getAwarded()
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getAwarded']),
    primarySite(sites) {
      let primary = {}
      sites.forEach((s) => {
        if (s.IsPrimarySite) {
          primary = s
        }
      })
      return primary.SiteAddress.SiteInsitutionName
    },

    openPOP(pop) {
      //debugger
      this.item = JSON.parse(JSON.stringify(pop))
      this.dialog = true
    },
    currentStatus(pop) {
      //debugger
      let list = JSON.parse(JSON.stringify(pop.POPStatus))
      list = list.sort((a, b) => {
        if (a.ChangedOn > b.ChangedOn) {
          return -1
        }
        if (a.ChangedOn < b.ChangedOn) {
          return 1
        }
        return 0
      })
      return list[0].Status.Description || ''
    },
    documentAdded(item) {
      this.refreshPOP()
    },
    refreshPOP() {
      this.getAwarded().then((res) => {
        this.item = res.data.filter((i) => {
          return i.Id == this.item.Id
        })[0]
      })
    },
  },
  computed: {
    ...mapGetters(moduleNameSpace, ['awarded']),
  },
  watch: {},
  components: {
    'pop-dialog': ProofOfPaymentVue,
  },
}
</script>

<style></style>
